document.addEventListener("DOMContentLoaded", function() {
    var a = document.querySelector(".article-content") || document.querySelector(".article__content") || document.querySelector(".article .rte") || document.querySelector(".rte");
    if (!a) return;
    var b = a.querySelector("#auto-toc");
    if (!b) return;
    var c = (b.getAttribute("data-toc-levels") || "h2,h3,h4").split(",").map(function(e) {
        return e.trim()
    }).filter(Boolean);
    c.length || (c = ["h2", "h3", "h4"]);
    var d = a.querySelectorAll(c.join(",")),
        e = Array.prototype.filter.call(d, function(e) {
            return !b.contains(e)
        });
    if (!e.length) {
        b.style.display = "none";
        return
    }
    var f = new Set;
    document.querySelectorAll("[id]").forEach(function(e) {
        f.add(e.id)
    });

    function g(h) {
        for (var i = h, j = 1; f.has(i);) i = h + "-" + j++;
        return f.add(i), i
    }
    var k = 1;
    e.forEach(function(h) {
        if (!h.id) {
            var i = "table-of-contents-" + k++;
            h.id = g(i)
        } else f.add(h.id)
    });
    var l = b.getAttribute("data-toc-title") || "Table of Contents",
        m = document.createElement("h2");
    m.textContent = l, m.id = g("toc-root");
    var n = document.createElement("nav");
    n.setAttribute("aria-label", "Table of contents"), n.setAttribute("role", "navigation");
    var o = document.createElement("ul");
    n.appendChild(o);
    var p = null,
        q = null,
        t = null,
        u = null;
    e.forEach(function(h) {
        var i = (h.textContent || "").trim();
        if (!i) return;
        var j = document.createElement("li"),
            r = document.createElement("a");
        r.setAttribute("href", "#" + h.id), r.textContent = i, j.appendChild(r);
        var s = h.tagName.toLowerCase();
        if ("h2" === s) {
            o.appendChild(j);
            p = j;
            q = null;
            t = null;
            u = null
        } else if ("h3" === s) {
            if (p) {
                q || (q = document.createElement("ul"), p.appendChild(q));
                q.appendChild(j);
                t = j;
                u = null
            } else {
                o.appendChild(j);
                t = j;
                u = null
            }
        } else if ("h4" === s) {
            if (t) {
                u || (u = document.createElement("ul"), t.appendChild(u));
                u.appendChild(j)
            } else {
                o.appendChild(j)
            }
        } else {
            o.appendChild(j)
        }
    }), b.textContent = "", b.appendChild(m), b.appendChild(n)
});